import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

/** B32116 — Appointment of DPO register summary (TASK_DATA.formData — PreSetAppointDpoPanel taskFormData 키) */
const appointDpoDetailMap = {
  title: 'New Data Protection Officer Details',
  fields: [
    { label: 'Full Name', key: ['dpoName', 'officerName'] },
    { label: 'Designation', key: ['dpoDesignation'] },
    { label: 'Contact Number', key: ['dpoContactNo'] },
    { label: 'Business Email', key: ['dpoEmail'] },
    { label: 'Date of Appointment', key: ['appointedDate', 'appointmentDate'] },
    { label: 'Lodgement Date', key: ['lodgementDate'] },
  ],
};

registerRegisterDetail('B32116', appointDpoDetailMap);
